import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
    name: 'config',
    initialState: { 
        // base_url    : process.env.NODE_ENV === 'production' ? 'https://lumobees.apps.binus.ac.id/binus/' : 'http://localhost:3000'
        // ,api_url    : process.env.NODE_ENV === 'production' ? 'https://lumobees.apps.binus.ac.id/binus/wp-json/vivaldi/v1' : 'http://localhost/vivaldi-backend/wp-json/vivaldi/v1'
        // ,socket_url : process.env.NODE_ENV === 'production' ? 'https://lumobees.apps.binus.ac.id' : 'http://localhost:4000'
        // ,socket_url_path : process.env.NODE_ENV === 'production' ? '/tvwall-server/socket.io' : '/socket.io'
        
        base_url    : process.env.REACT_APP_BASE_URL
        ,api_url    : process.env.REACT_APP_API_URL
        ,socket_url : process.env.REACT_APP_SOCKET_URL
        ,socket_url_path : process.env.REACT_APP_SOCKET_URL_PATH
        
        ,auth       : {
            basic      : 'Basic ZXhwbGJuczpleHBsYm5zX2szNA=='
        }
        ,colors : [
            '#028ed5'
            ,'#11BD74'
            ,'#d73930'
            ,'#F3931B'
            ,'#7D6B4E'
            ,'#e0e0e0'
            ,'#5e5e5e'
            ,'#ffffff'
        ]
        ,caps : {
            
        }
    }
    ,reducers : {}
});

export default configSlice.reducer;